import { ListBase } from 'react-admin';
import { MemberListLayout } from './MemberListLayout';

export const MemberList = () => {
    return (
        <ListBase
            resource="member"
            perPage={25}
            sort={{ field: 'lastSeen.nullslast', order: 'DESC' }}
        >
            <MemberListLayout />
        </ListBase>
    );
};
